import i18n from 'modules/core/lib/i18n'

import { TaskDefinition } from 'modules/inbox_tasks/lib/abstraction'

const DAYS_IN_WEEK = 7

export const TerminateEmployeeTaskDefinition: TaskDefinition<'EmployeesEmployeeName'> = {
  taskableTypename: 'EmployeesEmployeeName',

  getUrl: ({ info, navigation }) => {
    const employeeId = info.id

    if (!employeeId) {
      return null
    }

    return navigation.employees.id.terminate.fullPath({
      id: String(employeeId),
    })
  },

  getTitle: ({ info, dueOn }) => {
    const employeeName = info.fullName ?? null

    if (dueOn) {
      const dueDate = new Date(dueOn)
      const today = new Date()
      const diffInDays = Math.ceil((dueDate.getTime() - today.getTime()) / (1000 * 60 * 60 * 24))

      if (diffInDays > DAYS_IN_WEEK) {
        return i18n.t('employees.tasks.terminate.title_before_soon', {
          name: employeeName,
        })
      }
    }

    return i18n.t('employees.tasks.terminate.title_before', {
      name: employeeName,
    })
  },

  getMetadata: () => {
    return []
  },
}
